<template>
    <li id="nav-help" class="flex h-48 mb-8 w-full items-center justify-center mt-auto">
        <a :href="helpCenterUrl" target="_blank">
            <tooltip :content="$t('header.help')" offset="0,8">
                        <span class="flex trans-ease trans-ease p-8 border-4 text-primary-80 rounded-32 hover:text-primary-80">
                            <svg-icon class="w-16 h-16" type="help"></svg-icon>
                        </span>
            </tooltip>
        </a>
    </li>
</template>

<script>
import Tooltip from "./navigation/Tooltip.vue";
import SvgIcon from "./ui/SvgIcon.vue";

export default {
    name: "HelpLink",
    components: {
        Tooltip,
        'svg-icon': SvgIcon
    },
    computed: {
        helpCenterUrl() {
            let lang = 'nl';

            // > Disabled until we have help pages in other languages <
            //if (Jobtoolz.user && Jobtoolz.user.attributes.language)
            //    lang = Jobtoolz.user.attributes.language;

            return `https://help.jobtoolz.com/${lang}`;
        },
    }
}
</script>

<style scoped>

</style>
